(function() {
    /**
     * Toggle main hamburger menu
     *
     * @author      Mario Hoyos
     * @version     1.0.0
     */
    const menuButton = document.querySelector('#js-hamburger-button');
    const overlay    = document.querySelector('#js-overlay');

    function toggleMenu(){
        let navigation = document.querySelector('#js-menu-primary');
        let expanded   = menuButton.getAttribute('aria-expanded') === 'true' || false;

        //Toggle menu on hamburger click and only close it on overlay click or ESC key press
        if((this.id === menuButton.id ) || ((this.id === overlay.id || event.keyCode == 27) && expanded === true)) {
            //Toggle visibility classes
            navigation.classList.toggle('-is-visible');
            menuButton.classList.toggle('-is-open');
            overlay.classList.toggle('-is-visible');

            //Toggle the aria-expande attribute
            menuButton.setAttribute('aria-expanded', !expanded);
        }  
    }
    menuButton.onclick = toggleMenu;
    overlay.onclick = toggleMenu;
    //Close menu with ESC key press
    document.body.onkeydown = function(event){
        if ( event.keyCode == 27 ) {
            toggleMenu();            
        }
    };


    /**
     * Fix full-bleed overflow with visible scrollbars
     *
     * @author      Mario Hoyos
     * @version     1.0.0
     */
    function scrollbarFix(){
        let hasScrollbar = window.innerWidth > document.documentElement.clientWidth;

        if(hasScrollbar){
            let scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
            let fullBleedEls   = document.querySelectorAll(".h-full-bleed");

            fullBleedEls.forEach((el) => {
                el.style.setProperty('--full-bleed-width', 'calc(100vw - ' +  scrollbarWidth + 'px)');
                el.style.setProperty('--full-bleed-margin', 'calc(50% - 50vw + ' +  scrollbarWidth / 2 + 'px)');
            });
        } 
    }

    if (!Modernizr.hiddenscroll) {
        scrollbarFix();
        window.onresize = scrollbarFix;
    }


    /**
     * Remove :focus outline unless user is using the keyboard to navigate
     *
     * @author      Mario Hoyos
     * @version     1.0.0
     */
    function handleFirstTab(e) {
		if (e.keyCode === 9) {
			document.body.classList.add('h-user-is-tabbing');
			window.removeEventListener('keydown', handleFirstTab);
			window.addEventListener('mousedown', handleMouseDownOnce);
		}
	}
	function handleMouseDownOnce() {
		document.body.classList.remove('h-user-is-tabbing');
		window.removeEventListener('mousedown', handleMouseDownOnce);
		window.addEventListener('keydown', handleFirstTab);
	}
    window.addEventListener('keydown', handleFirstTab);


    /**
     * Animated scroll to anchor
     *
     * @author      Jeff Starr
     * @version     1.0.0
     * @see         https://perishablepress.com/vanilla-javascript-scroll-anchor/
     */
    function scrollTo() {
        const links = document.querySelectorAll('.h-scroll');
        links.forEach(each => (each.onclick = scrollAnchors));
    }

    function scrollAnchors(e, respond = null) {
        const distanceToTop = el => Math.floor(el.getBoundingClientRect().top);
        e.preventDefault();
        var targetID = (respond) ? respond.getAttribute('href') : this.getAttribute('href');
        const targetAnchor = document.querySelector(targetID);
        if (!targetAnchor) return;
        const originalTop = distanceToTop(targetAnchor);
        window.scrollBy({ top: originalTop, left: 0, behavior: 'smooth' });
        const checkIfDone = setInterval(function() {
            const atBottom = window.innerHeight + window.pageYOffset >= document.body.offsetHeight - 2;
            if (distanceToTop(targetAnchor) === 0 || atBottom) {
                targetAnchor.tabIndex = '-1';
                targetAnchor.focus();
                window.history.pushState('', '', targetID);
                clearInterval(checkIfDone);
            }
        }, 100);
    }
	window.onload = scrollTo;



	/**
     * Theme toggle
     *
     * @author      Andy Bell
     * @version     1.0.0
     * @see         https://hankchizljaw.com/wrote/create-a-user-controlled-dark-or-light-mode/
     */
	// Set text strings to allow translations
	const colorModeStrings = {
		'es' : {
			dark   : 'oscuro',
			light  : 'claro',
			notice : 'Se ha activado el tema ',
			enableLight : 'Activar tema claro',
			enableDark : 'Activar tema oscuro'
		},
		'en-US' : {
			dark   : 'dark mode',
			light  : 'light mode',
			notice : 'Color mode is now ',
			enableLight : 'Enable light theme',
			enableDark : 'Enable dark theme'      
		}
	}
	//Get the current lang
	const languageCode = document.documentElement.lang;
	
	//Define required variables
	const STORAGE_KEY       = 'user-color-scheme';
	const COLOR_MODE_KEY    = '--color-mode';
	const modeToggleButton  = document.querySelector('.js-mode-toggle');
	const modeToggleText    = document.querySelector('.js-mode-toggle-text');
	const modeStatusElement = document.querySelector('.js-mode-status');

	// Get current theme status
	const getCSSCustomProp = propKey => {
		let response = getComputedStyle(document.documentElement).getPropertyValue(propKey);
	  
		if (response.length) {
		  response = response.replace(/\"/g, '').trim();
		}
	  
		return response;
	};

	// Apply user preference
	const applySetting = passedSetting => {
		let currentSetting = passedSetting || localStorage.getItem(STORAGE_KEY);
	  
		if (currentSetting) {
		  document.documentElement.setAttribute('data-user-color-scheme', currentSetting);
		  setButtonLabelAndStatus(currentSetting);
		} else {
		  setButtonLabelAndStatus(getCSSCustomProp(COLOR_MODE_KEY));
		}
	};

	// Update button label
	const setButtonLabelAndStatus = currentSetting => {
		modeToggleButton.setAttribute('data-current-color-scheme', currentSetting);
		modeToggleText.innerText = currentSetting === 'dark' ? colorModeStrings[languageCode].enableLight : colorModeStrings[languageCode].enableDark;
		modeStatusElement.innerText = colorModeStrings[languageCode].notice + colorModeStrings[languageCode][currentSetting];
	};

	// Toggle color mode
	const toggleSetting = () => {
		let currentSetting = localStorage.getItem(STORAGE_KEY);
	  
		switch (currentSetting) {
		  case null:
			currentSetting = getCSSCustomProp(COLOR_MODE_KEY) === 'dark' ? 'light' : 'dark';
			break;
		  case 'light':
			currentSetting = 'dark';
			break;
		  case 'dark':
			currentSetting = 'light';
			break;
		}
	  
		localStorage.setItem(STORAGE_KEY, currentSetting);
	  
		return currentSetting;
	};

	// Add event to button
	modeToggleButton.addEventListener('click', evt => {
		evt.preventDefault();
		
		applySetting(toggleSetting());
	});
	
	applySetting(); 


	/**
     * Disable animations on resize
     *
     * @author      Andy Bell
     * @version     1.0.0
     * @see         https://css-tricks.com/stop-animations-during-window-resizing/
     */
	let resizeTimer;
	window.addEventListener("resize", () => {
		document.body.classList.add("js-resize-animation-stopper");
		clearTimeout(resizeTimer);
		resizeTimer = setTimeout(() => {
			document.body.classList.remove("js-resize-animation-stopper");
		}, 400);
	});


	/**
     * Break Simple Calendar dates into spans to style
     *
     * @author      Mario Hoyos
     * @version     1.0.0
     */
	jQuery('.simcal-date-format').each(function(){
		var words = jQuery(this).text().split(" ");
		jQuery(this).empty();
		var test = jQuery(this);
		jQuery.each(words, function(i, v) {
			test.append(jQuery("<span>").text(v));
		});
	})


	/**
     * Add privacy center toggle to footer menu
     *
     * @author      Mario Hoyos
     * @version     1.0.0
     */
	var footerMenu = document.getElementById('js-menu-footer');
	footerMenu.insertAdjacentHTML('beforeend', '<li class="[ c-menu__item ]"><button class="[ c-menu__link  c-menu__link--button ][ gdpr-preferences ]">Ajustes de privacidad</button></li>');
})();


/**
 * Check if notification was previously dismissed
 *
 * @author      Mario Hoyos
 * @version     1.0.0
 * @since       1.0.0
 */
function checkPollStatus(poll) {
  const expirationStatus =
    poll.getAttribute('data-expiration') === 'true' || false;
  let expired = false;
  if (expirationStatus) {
    const expirationUnixTimestamp = parseInt(
      poll.getAttribute('data-expiration-timestamp')
    );
    const currentUnixTimestamp = Math.round(Date.now() / 1000); // Convert to ms

    if (currentUnixTimestamp > expirationUnixTimestamp) {
      expired = true;
    }

  }

  const pollID = poll.getAttribute('data-poll-id');
	const pollResults = document.querySelector(`[data-poll-results-id="${pollID}"]`);
	const pollNotice = document.querySelector(`[data-poll-notice-id="${pollID}"]`);
	if (expired) {
		poll.setAttribute('data-show-poll', 'false');
		pollResults.setAttribute('data-show-poll', 'true');
		pollNotice.setAttribute('data-show-poll', 'true');
	}

}

const polls = document.querySelectorAll('.js-poll');
if (polls) {
	polls.forEach((item) => {
		checkPollStatus(item)
	})
}

// Make items sticky if enough space
const stickyEls = document.querySelectorAll('.js-sticky')

/**
 * Make element sticky only if there is enough vertical space for it
 *
 * @author      Mario Hoyos
 * @version     1.0.0
 * @since       2021.1
 */
 function makeSticky(el) {
	if (el) {
		const offset = 16

		if (el.clientHeight + offset < document.documentElement.clientHeight) {
			el.classList.add('u-sticky')
			el.classList.remove('u-non-sticky')
		} else {
			el.classList.remove('u-sticky')
			el.classList.add('u-non-sticky')
		}
	}
}

if (stickyEls) {
	stickyEls.forEach((item) => {
		makeSticky(item)
	})
}